import { useQuery } from 'react-query';
import { queryManagerMaps } from 'api/managerMap';
var useManagerMaps = function (options) {
    return useQuery(['getManagerMaps'], queryManagerMaps, options);
};
export default useManagerMaps;
